import axios from "axios";
import { get } from "../utils";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";

/**
 * Método wrapper para promesas en uso con
 * async / await para evitar el uso de try / catch
 * y mejor manejo de errores
 * @param {Promise} promise Promesa a ejecutar
 * @returns Array | [error, data]
 * @description Convierte una promesa en un array con el error y el resultado
 */
export const to = promise => {
  return promise.then(data => [null, data]).catch(err => [err]);
};

/**
 * Método wrapper para reintentar llamados
 * en caso de error
 * @param {Promise} promise Promesa a ejecutar
 *  @param {Number} delay Tiempo de espera entre reintentos (en ms)
 *  @param {Number} retries Número de reintentos
 * @returns Array | [error, data]
 * @description Convierte una promesa en un array con el error y el resultado
 */
export const retry = async (promiseFn, delay = 2000, retries = 5) => {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      const data = await promiseFn();
      return [null, data];
    } catch (err) {
      if (attempt === retries) {
        return [err];
      }
      if (delay > 0) {
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      attempt++;
    }
  }
};

const om = {
  /**
   * Realizar request genérica a la API
   *
   * @param {Object} payload payload para el endpoint
   */
  request({ endPoint, body }) {
    // Siempre retornar la promesa de axios
    return axios.post(endPoint, body);
  },
  sucursales({ latitud, longitud }) {
    return axios.get(
      `https://servicios.bbva.com.ar/openmarket/servicios/pois/v0/branches?latitude=${latitud}&longitude=${longitud}&radius=2500000&branchType=INTEGRAL`
    );
  },
  getResultVeridas(
    key,
    nroTramiteOferta,
    consulta,
    deviceId,
    deviceIdTimestamp,
    numeroCliente
  ) {
    let body = {
      key: key,
      numeroTramite: nroTramiteOferta,
      nroDoc: get(consulta, "numeroDoc", "") || get(consulta, "nroDoc", ""),
      c: get(consulta, "c", ""),
      deviceId,
      deviceIdTimestamp,
      tipoDocumento: get(consulta, "tipoDoc", ""),
      numeroCliente
    };

    return axios.post(`${API_BASE_SRC}/vdigital/wp/getResult`, body);
  },
  loginVeridas(consulta, deviceId, deviceIdTimestamp, numeroCliente) {
    let body = {
      nroDoc: get(consulta, "numeroDoc", "") || get(consulta, "nroDoc", ""),
      c: get(consulta, "c", ""),
      deviceId,
      deviceIdTimestamp,
      tipoDocumento: get(consulta, "tipoDoc", ""),
      numeroCliente
    };

    return axios.post(`${API_BASE_SRC}/vdigital/wp/login`, body);
  },
  downloadContract(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/descargarContratos`, body);
  },
  crearUsuario(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/usuarioYClave`, body);
  },
  normalizarCelular(payload) {
    let body = {
      level1: "AR",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      phoneNumber: payload,
      characteristic: "",
      postalCode: "",
      prefix: "",
      additionalData: ""
    };
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/normalizarTelefono`, body);
  },
  acortarUrl(url) {
    return axios.post(`${API_BASE_SRC}/utils/sUrl`, { url });
  },
  enviarResultadosBiometria(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(`${API_BASE_SRC}/dvs/wp/verificationProcess`, body);
  },
  consultarReintentosBio(payload) {
    return axios.get(`${API_BASE_SRC}/dvs/wp/countOfRecords?doc=${payload}`);
  },
  enviarEventoDvsFS(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(`${API_BASE_SRC}/dvs/wp/enviarEventoFS`, body);
  },
  validarRiesgoCliente(payload) {
    let body = JSON.parse(JSON.stringify(payload));
    return axios.post(`${API_BASE_SRC}/ventaTC/wp/validarRiesgo`, body);
  }
};

export default om;
